<template>
  <div>
    <!-- 影音搜尋資料區 -->
    <section>
      <div
        class="ytdwrap"
        v-bind:class="{ pushdown: plansData.selectedResultShow }"
      >
        <div v-if="currentDisplayPlans.length === 0">
          <p style="text-align: center;" class="findNothing">
            暫無資料，敬請期待
          </p>
        </div>

        <div
          class="clearfix info_item"
          v-for="plan in currentDisplayPlans"
          :key="plan.id"
        >
          <div @click="handleDownload(plan)">
            <div class="video-shadow">
              <img
                v-if="plan.imgUrl"
                width="400"
                height="200"
                :src="plan.imgUrl"
              />
              <img
                v-else
                width="400"
                height="200"
                src="@/images/img_default.png"
              />
            </div>

            <div class="textContent sdg-plans">
              <h3>{{ plan.title }}</h3>
              <p>格式：{{ plan.subtitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="video-modal" v-if="sdgPlansData.videoModal">
      <div class="video-modal-content">
        <video
          :src="sdgPlansData.videoModalSrc"
          controls
          controlsList="nodownload"
        ></video>
        <button @click="closeVideoModal"></button>
      </div>
    </div>
    <div class="topup" @click="scrollToTop()"></div>
  </div>
</template>

<script>
import { useDataContext } from "@/composable/plans";

export default {
  name: "SDGPlansComponent",
  setup() {
    return useDataContext();
  },
  data() {
    return {
      planID: this.$route.params.id,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    handleDownload(plan) {
      const isLoggedIn = window.hnalinLoginManager.isAuthenticated();
      if (isLoggedIn) {
        if (plan.type === "video" || plan.type === "audio") {
          this.sdgPlansData.videoModalSrc = plan.downloadLink;
          this.sdgPlansData.videoModal = true;
        } else {
          window.open(plan.downloadLink, "_blank");
        }
      } else {
        sessionStorage.setItem("redirectPath", window.location.pathname);
        sessionStorage.setItem("redirectQuery", plan.id);
        sessionStorage.setItem(
          "redirectPage",
          this.sdgPlansData.page.currentPage
        );
        window.hnalinLoginManager.login();
      }
    },

    closeVideoModal() {
      this.sdgPlansData.videoModal = false;
      this.sdgPlansData.videoModalSrc = null;
    },

    handleRedirectAfterDataLoad() {
      const isLoggedIn = window.hnalinLoginManager.isAuthenticated();
      if (!isLoggedIn) {
        return;
      } 

      if (
        sessionStorage.getItem("redirectQuery") &&
        this.sdgPlansData.planItems.length > 0 &&
        sessionStorage.getItem("redirectPage")
      ) {
        const planRecord = this.sdgPlansData.planItems.find(
          (plan) =>
            plan.id === parseInt(sessionStorage.getItem("redirectQuery"))
        );
        if (planRecord) {
          this.sdgPlansData.page.currentPage = parseInt(
            sessionStorage.getItem("redirectPage")
          );
          if (planRecord.type === "video" || planRecord.type === "audio") {
            this.sdgPlansData.videoModalSrc = planRecord.downloadLink;
            this.sdgPlansData.videoModal = true;
          } else {
            window.open(planRecord.downloadLink, "_blank");
          }
        }

        sessionStorage.removeItem("redirectQuery");
        sessionStorage.removeItem("redirectPage");
      }
    },
  },
  watch: {
    "sdgPlansData.planItems": {
      handler() {
        if (this.sdgPlansData.planItems.length > 0) {
          this.handleRedirectAfterDataLoad();
        }
      },
      immediate: true,
    },
  },
  computed: {
    currentDisplayPlans: function() {
      let page = this.sdgPlansData.page;
      if (page.currentPage === 0) {
        page.currentPage++;
      }
      let startIndex = (page.currentPage - 1) * page.pageSize;
      let lastIndex = page.currentPage * page.pageSize;
      return this.sdgPlansData.planItems.slice(startIndex, lastIndex);
    },
  },
};
</script>

<style scoped>
.findNothing {
  margin-top: 20%;
  font-size: 25px;
}

@media screen and (max-width: 1024px) {
  .findNothing {
    margin-top: 35%;
  }
}

@media screen and (max-width: 767px) {
  .pushdown {
    padding-top: 35px;
  }
}
@media screen and (max-width: 430px) {
  .findNothing {
    margin-top: 20%;
    font-size: 20px;
  }
  .pushdown {
    padding-top: 70px;
  }
}
</style>
